export const SET_CALENDAR_OPTION = 'SCHEDULING/SET_CALENDAR_OPTION';
export const SET_CALENDAR_LIST = 'SCHEDULING/SET_CALENDAR_LIST';
export const SET_MAP_LIST = 'SCHEDULING/SET_MAP_LIST';
export const SET_IS_CALENDAR_SELECTED = 'SCHEDULING/SET_IS_CALENDAR_SELECTED';
export const SET_DATE_CYCLE = 'SCHEDULING/SET_DATE_CYCLE';
export const SET_DATE_CYCLE_TEXT = 'SCHEDULING/SET_DATE_CYCLE_TEXT';
export const SET_MAP_SELECTED_DATE = 'SCHEDULING/SET_MAP_SELECTED_DATE';
export const SET_IS_MAP_SELECTED = 'SCHEDULING/SET_IS_MAP_SELECTED';
export const SET_IS_FIRST_SCHEDULING_ACCESS = 'SCHEDULING/SET_IS_FIRST_SCHEDULING_ACCESS'
export const SET_IS_BULK_UPDATE_LOADING = 'SCHEDULING/SET_IS_BULK_UPDATE_LOADING';
export const SET_IS_LOADING = 'SCHEDULING/SET_IS_LOADING';